<template>
  <div class="d-flex  flex-grow-1 flex-column">
    <md-progress-bar md-mode="indeterminate" class="w-100 d-flex"></md-progress-bar>
    <div class="d-flex flex-grow-1 align-items-center">
      <md-empty-state
        class="md-primary"
        md-rounded
        md-icon="check"
        md-label="Configurando a Página"
        md-description="A página está sendo configurada para melhor atende-lo">
      </md-empty-state>
    </div>
  </div>
</template>


<script>
import getUserCityData from "../scripts/getUserCityData";
import nameCityToCode from "../scripts/nameCityToCode";
import { CITY_SELECT, HOME } from "../consts/routes";

export default {
  name: "ConfigClientData",
  data() {
    return { sharedState: this.$store.state };
  },
  created() {
    const gucd = getUserCityData();

    gucd.then(data => {
      this.$store.commit("setCityInfo", {
        cityCode: nameCityToCode(data.nomeCidade),
        cityInfo: data
      });
      this.$store.dispatch("redirectTo", HOME);
    });

    gucd.catch(() => {
      this.$router.push(HOME);
    });
  }
};
</script>

<style scoped>
</style>
